// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__TnFQT","paper":"styles_paper__13Xn1","menuButton":"styles_menuButton__3jLsN"};